import { createMuiTheme } from '@material-ui/core/styles';

// A theme with custom primary and secondary color.

export const theme = createMuiTheme({
  text: {
    subtitle1: {
      color: 'rgba(12,31,44,0.87)',
      fontFamily: 'Roboto',
      fontSize: '16px'
    }
  },
  buttons: {
    textButton: {
      height: 36,
      border: 0,
      padding: '0 20px',
      backgroundColor: 'transparent',
      fontSize: '14px',
      fontWeight: 'bold',
      letterSpacing: '0.5px',
      lineHeight: '16px',
      fontFamily: 'Roboto',
      outline: 'none',
      cursor: 'pointer',
      textTransform: 'uppercase'
    },
    deleteTextButton: {
      color: '#F22D12',
      '&:hover': {
        backgroundColor: 'rgba(233, 46, 21, 0.06)'
      }
    }
  },
  typography: {
    useNextVariants: true,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    font: {
      main: 'Roboto',
      second: 'Rubik'
    },
    color: {
      main: 'rgba(12,31,44,0.87)',
      second: 'rgba(12,31,44,0.6)',
      light: 'rgba(12,31,44,0.38)'
    }
  },
  palette: {
    primary: {
      light: '#F2FAFF;',
      dark: '#0094EE',
      main: '#00A1FB',
      darker: '#0053A7',
      darkest: '#002940',
      contrastText: '#fff'
    },
    secondary: {
      light: '#E0F4FF',
      dark: '#496D91',
      main: '#02A1FB',
      mainDarker: '#0068C2',
      mainLighter: '#5A85B0',
      contrastText: '#fff'
    },
    error: {
      light: 'rgba(233, 46, 21, 0.06)',
      main: '#F22D12'
    },
    background: {
      paper: '#fff',
      default: '#eceef1'
    },
    disabled: {
      main: 'rgba(12,31,44,0.24)'
    }
  },
  breakpoints: {
    keys: ['xs', 'm', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      m: 479,
      sm: 899,
      md: 1023,
      lg: 1279,
      xl: 1479
    }
  }
});
